import type { ModuleManifest } from '../types.js'

/*
 * AI — BI-ийн (дараа нь Худалдан авалтын) API-г дуудаж ДУРЫН асуултад хариулдаг чат (docs/50, каталог docs/48).
 *
 * ! 🔴 ӨӨРИЙН БИЗНЕСИЙН ӨГӨГДӨЛГҮЙ. Тоо бүрийг BI-ийн цэгээс АСУУСАН ХЭРЭГЛЭГЧИЙН ӨӨРИЙН токеноор (loopback HTTP)
 * ! уншина — супер эрхтэй сервис данс ХЭЗЭЭ Ч БИШ. Тиймээс эх жагсаалтын эрх, модулийн сэлгүүр, хүрээ, BI-ийн
 * ! Basic / Менежер / Pro түвшин (`resolveBiAccess`) өөрчлөлтгүй үйлчилнэ. Энэ модуль зөвхөн чат, түүх, хэрэглээ эзэмшинэ
 * ! (`ai_conversations`, `ai_messages`, `ai_usage_daily`).
 *
 * ! Чатын ТҮВШИН = хэрэглэгчийн BI хандалт (Pro > Менежер (сувагтай) > Basic) — ТУСДАА `ai.pro:show` гэх мэт эрх
 * ! ЗАРЛААГҮЙ: хоёр дахь, зөрүүтэй түвшний толь үүсгэхгүйн тулд (docs/50 §5). Квот нь түвшнээр (env).
 */
export const aiModule = {
  key: 'ai',
  name: 'AI туслах',
  description:
    'BI-ийн тоонд тулгуурлан асуултад хариулдаг чат — таны өөрийн эрх, хүрээ, BI түвшнөөр (Basic / Менежер / Pro).',

  /* 0.1.0 — хөгжүүлэлтийн шатанд (docs/50 §15 нэвтрүүлэлт). */
  version: '0.1.0',
  icon: 'BotMessageSquareIcon',

  /*
   * ! УНТРААЛТТАЙ СУУЛГАНА. Шалтгаан: (1) `ANTHROPIC_API_KEY` тохируулаагүй орчинд модуль 503 `AI_NOT_CONFIGURED`
   * ! л өгнө — цэсэнд гарвал «эвдэрсэн» мэт; (2) дуудлага бүр МӨНГӨ (docs/50 §12). Түлхүүр, квотоо тохируулсны дараа
   * ! Тохиргоо ▸ Модулиуд дээрээс асаана. Энэ нь ЗӨВХӨН ШИНЭ суулгацын анхдагч — мөр үүссэний дараа сэлгүүр л шийднэ.
   */
  enabledByDefault: false,

  permissions: [
    /*
     * ! ЧАТ АШИГЛАХ. Хариултын АГУУЛГЫГ энэ эрх нээхгүй — тоо бүр эх BI цэгийн эрхээр (`erp.reports:list` …) хаалттай
     * ! хэвээр; эрхгүй хэрэгсэл 403 → AI «танд энэ мэдээллийн эрх алга» гэнэ. PIN/апп (`sid`) сессэд ХҮРЭХГҮЙ
     * ! (`APP_ALLOWED_PERMISSIONS`-д ОРОХГҮЙ + контроллер `PanelSessionGuard`) — зөвхөн панел.
     */
    { resource: 'ai.chat', action: 'use', description: 'AI туслахтай чатлах (хариулт таны өөрийн BI эрхээр)' },

    /*
     * ! БҮХ хэрэглэгчийн хэрэглээ (мессеж, токен, зардлын тооцоо) — админд. Өөрийн хэрэглээг `ai.chat:use` хангалттай.
     * ! Мессежийн АГУУЛГА энд ХЭЗЭЭ Ч харагдахгүй (зөвхөн тоо).
     */
    { resource: 'ai.usage', action: 'list', description: 'AI туслахын бүх хэрэглэгчийн хэрэглээ, зардлын тооцоо харах' },
  ],

  navigation: [
    {
      /*
       * ! Дарааллыг БҮҮ ХОЛИ: эхний мөр нь модулийн «буух хуудас» (`navDestinations[].landing`).
       */
      label: 'AI',
      items: [
        {
          label: 'AI туслах',
          href: '/ai',
          icon: 'BotMessageSquareIcon',
          // ! Tailwind зөвхөн apps/admin-ийг уншдаг — admin-д аль хэдийн байгаа өнгөний класс л (fuchsia алга).
          iconClassName: 'text-rose-600 dark:text-rose-400',
          permission: 'ai.chat:use',
        },
        {
          label: 'Хэрэглээ',
          href: '/ai/usage',
          icon: 'GaugeIcon',
          iconClassName: 'text-slate-600 dark:text-slate-400',
          permission: 'ai.usage:list',
        },
      ],
    },
  ],

  /*
   * ! REFINE-ИЙН RESOURCE ЗАРЛААГҮЙ — чат нь SSE (`POST /ai/conversations/:id/messages`), CRUD жагсаалт биш; админ
   * ! `views/apps/ai/api/*`-аар шууд дуудна (BI-ийн `persist/*`-тэй ижил шийдэл).
   */
  resources: [],
} as const satisfies ModuleManifest
